import { apiCaller } from '../ApiCaller/ApiCaller';

export async function updateAccountDataOfContact(accountData) {

    const updateAccountData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/updateAccountDetail", accountData);

      return updateAccountData;
}